import React, { useState, useEffect } from 'react';

import { Dialog } from 'primereact/dialog';
import { Fieldset } from 'primereact/fieldset';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import { LanguageService } from '../../service/LanguageService';

export function ContaAzulConfiguration(props) {

    const CREDENTIALS_STEP = "Credentials";
    const ERROR_STEP = "Error";
    const SUCCESS_STEP = "Success";

    const [step, setStep] = useState("");
    const [clientId, setClientId] = useState("");
    const [clientSecret, setClientSecret] = useState("");
    //const [caReturn, setCaReturn] = useState(null);

    const languageService = new LanguageService();

    useEffect(() => {
        async function fetchData() {
            const _caReturn = localStorage.getItem("ca_return");
            console.log("_caReturn", _caReturn);
            // setCaReturn(_caReturn);
            setStep(_caReturn ? _caReturn === "0" ? ERROR_STEP : SUCCESS_STEP : CREDENTIALS_STEP);
            await localStorage.removeItem("ca_return"); 
        }
        fetchData();
    }, []);

    const nextStep = async () => {
        if(step === CREDENTIALS_STEP){            
            const _returnURL = window.location.href.split("config").join("returnContaAzul");
            await localStorage.setItem("ca_clientIdAndSecretSha",Buffer.from(`${clientId}:${clientSecret}`).toString('base64'));
            await localStorage.setItem("ca_returnURL",_returnURL);  
            await localStorage.removeItem("ca_error");  
            window.location.href = `https://api.contaazul.com/auth/authorize?redirect_uri=${_returnURL}&client_id=${clientId}&scope=sales&state=askdsdfsdskd29`;
        }
    }

    const isNextStepDisabled = () => {
        if(step === "Credentials" && (clientId === "" || clientSecret === "")){
            return true;
        }

        return false
    }

    const restart = async () => {
        setStep(CREDENTIALS_STEP);
        setClientId("");
        setClientSecret("");
        await localStorage.removeItem("ca_clientIdAndSecretSha");
        await localStorage.removeItem("ca_returnURL");  
        await localStorage.removeItem("ca_error");  
         
    }

    return (
        <Dialog 
            visible={props.visible} 
            style={{ width: '50vw' }} 
            header="Configuração Conta Azul" 
            modal 
            footer={
                <>
                    { 
                        step === ERROR_STEP ? <Button label={languageService.getText("Reiniciar")} icon="pi pi-refresh" className="p-button-text" onClick={restart} />
                        : step === SUCCESS_STEP ? <Button label={languageService.getText("Fechar")} icon="pi pi-refresh" className="p-button-text" onClick={() => {
                                restart();
                                props.onConfigEnded();
                            }
                        } />
                        : <Button disabled={isNextStepDisabled()} label={languageService.getText("Continuar")} icon="pi pi-check" className="p-button-text" onClick={() => nextStep()} />
                    }
                </>
            } 
            onHide={props.onConfigEnded}
            >

            { step === CREDENTIALS_STEP && 
                <>
                    <Fieldset legend={"Credenciais"} style={{marginBottom: '5px'}}>
                        <div className="p-formgrid p-grid">
                            <div className="p-field p-col-12 p-lg-6">
                                <label htmlFor="description">Client ID*</label>
                            </div>
                            <div className="p-field p-col-12 p-lg-6">
                                <label htmlFor="description">Client Secret*</label>
                            </div>
                            <div className="p-field p-col-12 p-lg-6">
                                <InputText id="clientId" value={clientId} onChange={(e) => setClientId(e.target.value)}  style={{width: '100%'}} />
                            </div>
                            <div className="p-field p-col-12 p-lg-6">
                                <InputText id="clientSecret" value={clientSecret} onChange={(e) => setClientSecret(e.target.value)}  style={{width: '100%'}} />
                            </div>
                        </div>
                    </Fieldset> 
                </>
            }

            { step === ERROR_STEP &&  <>
                <p style={{color: 'red'}}>{localStorage.getItem("ca_error")}</p>
            </>}

            { step === SUCCESS_STEP &&  <>
                <p style={{color: 'green'}}>Configuração finalizada com sucesso</p>
            </>}

            
        </Dialog>
    );
}